// extracted by mini-css-extract-plugin
export default {"notfound":"NotFound_notfound__AujGZ"};